<template>
    <div
      class="finantial-settings-payout-methods-page"
      v-loading="isLoading"
    >
      <!-- Subtitle Bank Account  -->
      <h2
        v-if="!showEmptyPaymentMethodsPage"
        class="app-content-subtitle"
      >
        <app-i18n code="subpropertySettings.finantial.payoutMethods.subtitle.bankAccount"/>
      </h2>
      
      <!-- Payment Method Empty -->
      <app-empty-page
        v-if="showEmptyPaymentMethodsPage"
        :icon-class="payoutMethodsEmpty.iconClass"
        :empty-text="payoutMethodsEmpty.emptyText"
        :text-button="payoutMethodsEmpty.textButton"
        :on-click-button-fn="payoutMethodsEmpty.onClickButtonFn"
      />

      <!-- Payment List -->
      <div
        v-else
        class="finantial-settings-payout-methods-page__list"
      >
        <finantial-settings-payout-methods-card 
          v-for="(item, index) in payoutsMethods"
          :key="index"
          class="finantial-settings-payout-methods-page__list__elem"
          :id="item.id"
          :property-id="propertyId"
          :subproperty-id="subpropertyId"
          :connected-account-id="connectedAccountId"
          :is-default="item.defaultForCurrency"
          :title="item.bankName"
          :last4="item.last4"
          :description="item.holderName"
          :status="item.status"
          :country="item.country"
        />
      </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { i18n } from '@shared/i18n';
import FinantialSettingsPayoutMethodsCard from '@modules/subproperty-settings/finantial-settings/finantial-settings-payout-methods/components/finantial-settings-payout-methods-card.vue';

export default {
  name: 'finantial-settings-payout-methods-page',

  props: {
    propertyId: {
      type: String,
      required: true
    },
    subpropertyId: {
      type: String,
      required: true
    },
    connectedAccountId: {
      type: String,
      required: true
    },
  },

  mounted() {
    this.doList({ propertyId: this.propertyId, connectedAccountId: this.connectedAccountId});
  },

  computed: {
    ...mapGetters({
      currentManage: 'auth/manage/currentManage',
      payoutsMethods: 'paymentSettings/payoutMethods/payoutsMethods',
      loadingPayoutsMethods: 'paymentSettings/payoutMethods/loadingPayoutsMethods',
    }),

    isLoading() {
      return this.loadingPayoutsMethods;
    },
  
    showEmptyPaymentMethodsPage() {
      return this.payoutsMethods.length === 0 && !this.loadingPayoutsMethods;
    },

    payoutMethodsEmpty() {
      return {
        iconClass: "icon-card",
        emptyText: i18n('subpropertySettings.finantial.payoutMethods.emptyText'),
        textButton: i18n('subpropertySettings.finantial.payoutMethods.emptyButton'),
        onClickButtonFn: this.onClickButtonEmpty
      }
    },
  },

  methods: { 
    ...mapActions({
      doList: 'paymentSettings/payoutMethods/doList',
    }),
    onClickButtonEmpty() {
      this.$router.push({
        name: 'stripeExternalAccountCreate',
        params: {
          connectedAccountId: this.connectedAccountId,
        }
      });
    }
  },

  components: {
    FinantialSettingsPayoutMethodsCard,
  },
}
</script>

<style lang="scss" scoped>

.finantial-settings-payout-methods-page {
  &__list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 16px;

    @include mobile {
      grid-template-columns: 1fr;
    }

    @include tablet {
      grid-template-columns: 1fr;
    }

    @include desktop {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

</style>